import { render, staticRenderFns } from "./WorkFlowDetail.vue?vue&type=template&id=296858d4&scoped=true&"
import script from "./WorkFlowDetail.vue?vue&type=script&lang=js&"
export * from "./WorkFlowDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorkFlowDetail.vue?vue&type=style&index=0&id=296858d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296858d4",
  null
  
)

export default component.exports